import { useQuery } from '@hooks/reactQuery';

import {
	getAllCells4GFdd,
	getAllCells4GTdd,
	getAllCells5G,
} from '@api/manageCell';
import {
	getAllCells4GFddLimenet,
	getAllCells4GTddLimenet,
	getAllCells5GLimenet,
} from '@api/manageCellsLimenet';

import { IAllCellsDTO } from '@interfaces/cells/dto/cellsDTO';
import { TDefaultDTO } from '@interfaces/common/defaultDTO';

import { ETechnologiesValues, EVendorsValues, TTechnologiesValues, TVendorsValues } from '@enums/common';

import { ALL_CELLS } from '@constants/queryKeys';

interface IUseAllCellsParams extends TDefaultDTO, IAllCellsDTO {
	technologyValue?: TTechnologiesValues;
	vendor: TVendorsValues;
	node?: string;
	siteId: string;
}

export const useQueryCells = (params: IUseAllCellsParams) => {
	const {
		technologyValue,
		vendor,
		page,
		pageSize,
		searchValue,
		siteId,
		band,
		siteType,
		sortDirection,
		sortFieldName,
		node,
	} = params || {};

	const {
		data: dataSites,
		isInitialLoading: isLoadingSites,
	} = useQuery({
		queryKey: [
			ALL_CELLS,
			technologyValue,
			vendor,
			page,
			pageSize,
			searchValue,
			siteId,
			band,
			siteType,
			sortDirection,
			sortFieldName,
			node,
		],
		queryFn: () => {
			const params = {
				page,
				pageSize,
				searchValue,
				siteType,
				band,
				...(sortFieldName
					? {
						sortFieldName,
						sortDirection,
					}
					: null),
			};

			switch (vendor) {
				case EVendorsValues.nokia: {
					switch (technologyValue) {
						case ETechnologiesValues.T_4G_TDD:
							return getAllCells4GTdd({ ...params, ENodeBId: node });
						case ETechnologiesValues.T_4G_FDD:
							return getAllCells4GFdd({ ...params, ENodeBId: node });
						case ETechnologiesValues.T_5G:
							return getAllCells5G({ ...params, GNodeBId: node });
						default:
							return Promise.resolve({ items: [], count: 0 });
					}
				}
				case EVendorsValues.limenet: {
					switch (technologyValue) {
						case ETechnologiesValues.T_4G_TDD:
							return getAllCells4GTddLimenet({ ...params, ENodeBId: node });
						case ETechnologiesValues.T_4G_FDD:
							return getAllCells4GFddLimenet({ ...params, ENodeBId: node });
						case ETechnologiesValues.T_5G:
							return getAllCells5GLimenet({ ...params, GNodeBId: node });
						default:
							return Promise.resolve({ items: [], count: 0 });
					}
				}
				default:
					return Promise.resolve({ items: [], count: 0 });
			}
		},
		enabled: [!!technologyValue],
		refetchOnWindowFocus: false,
	});

	return {
		isLoadingTable: isLoadingSites,
		allCells: dataSites?.items || [],
		cellsCount: dataSites?.count || 0,
	};
};
